import { render, staticRenderFns } from "./TrueFalseQuestionFields.vue?vue&type=template&id=6ee65d73&"
import script from "./TrueFalseQuestionFields.vue?vue&type=script&lang=js&"
export * from "./TrueFalseQuestionFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports